import { render, staticRenderFns } from "./OpenPopupLayout.vue?vue&type=template&id=5f5e6e40&scoped=true"
import script from "./OpenPopupLayout.vue?vue&type=script&lang=js"
export * from "./OpenPopupLayout.vue?vue&type=script&lang=js"
import style0 from "./OpenPopupLayout.vue?vue&type=style&index=0&id=5f5e6e40&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5e6e40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f5e6e40')) {
      api.createRecord('5f5e6e40', component.options)
    } else {
      api.reload('5f5e6e40', component.options)
    }
    module.hot.accept("./OpenPopupLayout.vue?vue&type=template&id=5f5e6e40&scoped=true", function () {
      api.rerender('5f5e6e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/OpenPopupLayout.vue"
export default component.exports